import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { LIST_CARD_ORDER } from '../../../../constants';
import { type PassBundleRaw } from '../../../../types';
import ImgCard from '../ImgCard/ImgCard';

import styles from './ListCards.scss';

interface Props {
  passesData: PassBundleRaw;
  handleCardClick(): void;
}

const ListCards: React.FC<Props> = ({ passesData, handleCardClick }) => {
  const isEmbedded = useSelector(select.device.isDesktopEmbedded);
  const cardData = LIST_CARD_ORDER.map(({ cardType }) => {
    const cards = passesData[cardType];
    return !cards.length ? { type: cardType, tallPromoImage: '' } : cards[0];
  });

  return (
    <div
      className={classNames(styles.cardWrapper, {
        [styles.embedded]: isEmbedded
      })}
    >
      {cardData.map(
        (card, index) => card && <ImgCard key={index} onClick={handleCardClick} card={card} />
      )}
    </div>
  );
};

export default ListCards;
